import request from '@teetsh/app/src/utils/request';
import { useMutation } from '@tanstack/react-query';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { NiveauValue } from 'containers/scholarSystem';

interface Props {
  schoolyearId: string;
  schoolId: string;
  edtId: string;
  destEDTId: string;
  classroomsNiveauxMapping: ClassroomsNiveauxMapping;
}

type ClassroomsNiveauxMapping = Array<{
  classroomId: string;
  niveau: NiveauValue | 'IGNORE';
}>;

function sendToCMS({
  schoolyearId,
  schoolId,
  edtId,
  destEDTId,
  classroomsNiveauxMapping,
}: Props) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/emplois-du-temps/${edtId}/public-share`;
  return request(requestURL, {
    method: 'POST',
    body: {
      classroomsNiveauxMapping,
      destEDTId,
    },
  });
}

export default function useSendToCMS() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { mutateAsync } = useMutation({
    mutationFn: ({
      edtId,
      destEDTId,
      classroomsNiveauxMapping,
    }: {
      edtId: string;
      destEDTId: string;
      classroomsNiveauxMapping: ClassroomsNiveauxMapping;
    }) =>
      sendToCMS({
        edtId,
        schoolId: school.id,
        schoolyearId: schoolyear.id,
        classroomsNiveauxMapping,
        destEDTId,
      }),

    onSuccess: () => {},
  });
  return mutateAsync;
}
